import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core'
import { CommonModule } from '@angular/common'
import { TimeSegment } from '../../models/DateTime/TimeSegment'

@Component({
  selector: 'app-date-range-view',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './date-range-view.component.html',
  styleUrls: ['./date-range-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DateRangeViewComponent implements OnChanges {
  @Input() startTimeSegment: TimeSegment
  @Input() startDate: Date
  @Input() endTimeSegment: TimeSegment
  @Input() endDate: Date
  @Input() showYear: boolean = false

  @Input() dateScale: number = 1
  @Input() timeScale: number = 1

  @Input() justifyContent: 'left' | 'right' | 'space-evenly' = 'space-evenly'

  private defaultDateFontSizeEm = 0.6
  private defaultTimeFontSizeEm = 1

  protected itemDateStyle
  protected itemTimeStyle
  protected justifyContentStyle

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    this.refreshStyles()
  }

  private refreshStyles() {
    this.itemDateStyle = {
      'fontSize.em': this.defaultDateFontSizeEm * this.dateScale,
    }
    this.itemTimeStyle = {
      'fontSize.em': this.defaultTimeFontSizeEm * this.timeScale,
    }
    this.justifyContentStyle = {
      justifyContent: this.justifyContent,
    }
  }
}
